<template>
  <div class="media-manager">
    <div class="imagens-container">
      <div v-if="midias && midias.length" class="imagens-preview">
        <div v-for="(m, i) in midias" :key="i" class="imagem-item" @click="$emit('abrirModalPreview', i)">
          <img v-if="m.tipo !== 'video'" :src="m.dados" class="imagem-preview" />
          <div v-else style="position: relative; height: 100%; width: 100%;">
            <video class="imagem-preview" style="width: 100%; height: 100%; object-fit: cover;">
              <source :src="m.dados" type="video/mp4" />
            </video>
            <div
              class="d-flex align-center justify-center"
              style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.1);"
            >
              <v-icon color="white" size="30">
                mdi-play-circle-outline
              </v-icon>
            </div>
          </div>
          <v-btn icon x-small @click.stop="remover(i)" class="btn-remover-img"><v-icon x-small>mdi-close</v-icon></v-btn>
        </div>
      </div>
      <p v-else class="grey--text">Nenhuma mídia adicionada</p>
    </div>
    <v-file-input 
      :error-messages="arquivoErro ? 'Tamanho de arquivo maior que o permitido.' : '' " 
      :error="arquivoErro"
      v-model="arquivo" 
      accept="image/*,video/*" 
      label="Selecionar foto ou vídeo (máx 10MB)" 
      @change="aoArquivoSelecionado" 
      dense 
      outlined
      ></v-file-input>
    <div class="d-flex gap-2 mt-2">
      <v-btn small color="primary" dark @click="$emit('abrirCamera')">Abrir Câmera</v-btn>
    </div>
  </div>
</template>

<script>
import useTempMedia from '@/composables/useTempMedia';
import '@/components/coleta/coleta.css'; 

const MAX_FILE_SIZE = 10 * 1000 * 1000;

export default {
  name: 'GerenciadorMidia',
  props: {
    chaveItem: { type: [String,Number], required: true },
    midiasIniciais: { type: Array, default: () => [] }
  },
  data() {
    return { 
      arquivo: null,
      midias: (this.midiasIniciais || []).slice(),
      arquivoErro: false
    };
  },
  watch: {
    midiasIniciais(v) { this.midias = (v || []).slice(); }
  },
  methods: {
    async preciseDate(date) {
      const dateArray = [
        (`00${date.getDate()}`).slice(-2),
        (`00${date.getMonth() + 1}`).slice(-2),
        date.getFullYear(),
        '_',
        (`00${date.getHours()}`).slice(-2),
        (`00${date.getMinutes()}`).slice(-2),
        (`00${date.getSeconds()}`).slice(-2),
      ];
      return dateArray.join();
    },

    async dataURLtoFile(dataurl, filename){
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n) {
        u8arr[n - 1] = bstr.charCodeAt(n - 1);
        n -= 1; // to make eslint happy
      }
      return new File([u8arr], filename, { type: mime });
    },

    async aoArquivoSelecionado(file) {
      if (!file) {
        this.arquivoErro = false;
        return;
      }
      console.log('TAMANHO DO ARQUIVO', file.size, MAX_FILE_SIZE)
      if (file.size > MAX_FILE_SIZE) {
        this.arquivoErro = true;
        this.arquivo = null;
        return;
      }
      this.arquivoErro = false;

      console.log('FILE', file)
      const date = await this.preciseDate(new Date());

      const semExt = file.name.split('.')[0];
      const filename = semExt.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

      const nome = `${filename}|${this.chaveItem}|_,${date}`;
      console.log('adicionando file', file,  nome)
      const reader = new FileReader();
      reader.onload = (e) => {
        const tipo = file.type.startsWith('video') ? 'video' : 'image';
        const newFile = new File([file], nome, { type: file.type });
        const obj = { tipo, dados: e.target.result, blob: newFile };
        this.midias.push(obj);
        const t = useTempMedia();
        t.adicionar(this.chaveItem, obj);
        this.$emit('atualizar:midias', this.midias.slice());
        this.arquivo = null;
      };
      reader.readAsDataURL(file);
    },
    remover(index) {
      const t = useTempMedia();
      t.remover(this.chaveItem, index);
      this.midias.splice(index, 1);
      console.log(index, this.chaveItem);
      this.$emit('atualizar:midias', this.midias.slice());
    }
  }
};
</script>

<style scoped>
.imagem-item { position:relative; width:100px; height:100px; margin-right:8px; display:inline-block; }
.imagem-preview { width:100%; height:100%; object-fit:cover; }
.btn-remover-img { position:absolute; top:2px; right:2px; background:white !important; }
</style>
